import useStoreState from './state'

const Context = ctx('userId')

const useStore = initData => useStoreFactory(useStoreState, { initData })

export { Context, useStore }
